module.exports = __webpack_public_path__ + "img/slide-logo.9fc417b0.jpg";